export const getUrlString = (text: string) => {
  const regex = /[^a-zA-Z0-9]+/g;
  const transformedText = text.toLowerCase().replace(regex, '_');
  return transformedText;
};

export const getAdvancedQueryParts = (inputString: string) => {
  const separatorRegex = new RegExp(`\\b(AND|OR)\\b`);
  return inputString.split(separatorRegex);
};

export const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return;
  // Remove all non-digit characters from the phone number
  const digitsOnly = phoneNumber.replace(/\D/g, '');

  // Check if the phone number is valid (10 or 11 digits for US/CA)
  if (digitsOnly.length === 10) {
    return digitsOnly.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }

  if (digitsOnly.length === 11) {
    return digitsOnly.replace(/(\d)(\d{3})(\d{3})(\d{4})/, '1 ($2) $3-$4');
  }
  // Invalid phone number length
  return phoneNumber;
};

export function formatPhoneNumberAndValidate(input: HTMLInputElement) {
  // Remove non-digit characters from the input
  let phoneNumber = input.value.replace(/\D/g, '');

  // Apply the format (###) ###-####
  if (phoneNumber.length === 10) {
    phoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    input.value = phoneNumber;
    return true;
  } else {
    return false;
  }
}
